import { render, staticRenderFns } from "./ClientEmail.vue?vue&type=template&id=66835e50"
import script from "./ClientEmail.vue?vue&type=script&lang=js"
export * from "./ClientEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports